<template>
  <div class="container">
    <div class="PieBar">
      <div class="pieTitle"></div>
      <div class="leftPieChart">
        <h3>本月短信账号使用情况</h3>
        <div class="empty-style" v-if="date.length == 0">
          <a-empty />
        </div>
        <a-skeleton active :loading="loadingCropIdPie" v-else>
          <v-chart :forceFit="true" :height="height" :data="date" :scale="scale">
            <v-tooltip :showTitle="false" dataKey="item*percent" />
            <v-axis />
            <v-legend dataKey="item" />
            <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
            <v-coord type="theta" />
          </v-chart>
        </a-skeleton>
      </div>
      <div class="rightPieChart">
        <h3>本月短信类型使用情况</h3>
        <div class="empty-style" v-if="date2.length == 0">
          <a-empty />
        </div>
        <a-skeleton active :loading="loadingMessageTypePie" v-else>
          <v-chart :forceFit="true" :height="height" :data="date2" :scale="scale">
            <v-tooltip :showTitle="false" dataKey="item*percent" />
            <v-axis />
            <v-legend dataKey="item" />
            <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
            <v-coord type="theta" />
          </v-chart>
        </a-skeleton>
      </div>
    </div>
    <div class="barChar">
      <h3 style="margin-left: 1%">短信模板使用统计</h3>
      <div class="empty-style" v-if="barDate.length == 0">
        <a-empty />
      </div>
      <a-skeleton active :loading="loadingTemplateUse" v-else>
        <div class="canvas">
          <v-chart :forceFit="true" :height="userTimesH" :data="barDate">
            <v-coord type="rect" direction="LB" />
            <v-tooltip :shared="true" />
            <v-axis dataKey="times" :label="label" :tickLine="tickLine" />
            <v-interval position="templateCode*times" :label="labelInterval" />
          </v-chart>
        </div>
      </a-skeleton>
    </div>
  </div>
</template>


<script>
import { getCountThisMouthSendType, getCountTemplateUseTimes, getCountThisMouthMessageType } from '@/api/api'
const DataSet = require('@antv/data-set')

const label = {
  textStyle: {
    fill: '#8d8d8d',
  },
  offset: 10,
}

const tickLine = {
  alignWithLabel: false,
  length: 0,
}

const labelInterval = [
  'times',
  {
    useHtml: true,
    htmlTemplate: function htmlTemplate(text, item) {
      var a = item.point
      if (a.times > 100000) {
        return '<span class="g2-label-item" style="font-size:8px;color:#FF8C00">' + a.times + '</span>'
      } else if (a.times == 0) {
        return '<span class="g2-label-item" style="font-size:8px;color:#DC143C">' + a.times + '</span>'
      } else {
        return '<span class="g2-label-item" style="font-size:8px">' + a.times + '</span>'
      }
    },
  },
]

export default {
  data() {
    return {
      label,
      tickLine,
      labelInterval,
      date: [],
      date2: [],
      barDate: [],
      height: 400,
      userTimesH: 400,
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1,
      },
      labelConfig: [
        'percent',
        {
          formatter: (val, item) => {
            return item.point.item + ': ' + val
          },
        },
      ],
      scale: [
        {
          dataKey: 'percent',
          min: 0,
          formatter: '.0%',
        },
      ],
      padding: ['auto', 'auto'],
      loadingTemplateUse: false,
      loadingCropIdPie: false,
      loadingMessageTypePie: false,
    }
  },
  mounted() {
    this.getSectorDate()
    this.getCountThisMouthMessageType()
    this.getBarDate()
  },
  methods: {
    getSectorDate() {
      this.loadingCropIdPie = true
      getCountThisMouthSendType().then((res) => {
        if (res.success) {
          const dv = new DataSet.View().source(res.result)
          dv.transform({
            type: 'percent',
            field: 'count',
            dimension: 'item',
            as: 'percent',
          })
          this.date = dv.rows
          this.loadingCropIdPie = false
        } else {
          this.loadingCropIdPie = false
          this.$message.error(res.message)
        }
      })
    },
    getCountThisMouthMessageType() {
      this.loadingMessageTypePie = true
      getCountThisMouthMessageType().then((res) => {
        if (res.success) {
          const dv = new DataSet.View().source(res.result)
          dv.transform({
            type: 'percent',
            field: 'count',
            dimension: 'item',
            as: 'percent',
          })
          this.date2 = dv.rows
          this.loadingMessageTypePie = false
        } else {
          this.loadingMessageTypePie = false
          this.$message.error(res.message)
        }
      })
    },
    getBarDate() {
      this.loadingTemplateUse = true
      getCountTemplateUseTimes().then((res) => {
        if (res.success) {
          this.barDate = res.result
          let hNum = res.result.length / 4
          if (hNum <= 2) {
            hNum = 2
          }
          this.userTimesH = hNum * 200
          this.loadingTemplateUse = false
        } else {
          this.loadingTemplateUse = false
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style scoped>
.leftPieChart {
  width: 48%;
  height: 100%;
  margin-top: 1%;
  margin-left: 1%;
  display: inline-block;
}
.rightPieChart {
  width: 48%;
  height: 100%;
  margin-top: 1%;
  margin-left: 1%;
  display: inline-block;
}
.PieBar {
  background-color: #ffffff;
  width: 100%;
}
.barChar {
  background-color: #ffffff;
  width: 100%;
  margin-top: 1%;
  padding-top: 1%;
  padding-left: 2%;
}
.canvas {
  width: 94%;
  margin: auto;
}
.empty-style {
  padding-top: 10%;
  padding-bottom: 10%;
}
</style>
